import $ from "jquery";

import Backdraft from "backdraft-app/src/backdraft";

import { default as template } from "../../templates/keyboard_shortcuts/modal.jst";

import Loading from "shared/loading";

import "vendor/bootstrap_switch";

import Window from "shared/window_location";

Backdraft.app("Header", function(app) {
  app.view.modal("KeyboardShortcutsModal", {
    title: function() {
      return "<span class='vertically-center-items' style='height:40px;'>" +
               "<span style='font-size:2em;padding-top:10px'>" +
                 "&#9000 &nbsp; " +
               "</span>" +
               "Keyboard Shortcuts</span>";
    },

    className: "modal-force-light",

    size: "large",

    template,

    initialize: function(options) {
      app.Views.KeyboardShortcutsModal.__super__.initialize.apply(this, arguments);
      this.config = options;
    },

    body: function() {
      return this.template(this.config);
    },

    render: function() {
      app.Views.KeyboardShortcutsModal.__super__.render.apply(this, arguments);
      var node = $('<div class="mr-auto"><input type="checkbox" name="keyboard-shortcuts-checkbox" checked></div>');
      this.$('.modal-footer').prepend(node).find('[name=keyboard-shortcuts-checkbox]').bootstrapSwitch({
        size: "small",
        animate: true,
        state: !$.cookie('disable_keyboard_shortcuts'),
        onSwitchChange: function(event, state) {
          const COOKIE_NAME = 'disable_keyboard_shortcuts';
          const newCookieDisabled = $.cookie(COOKIE_NAME) ? null : true;
          $.cookie(COOKIE_NAME, newCookieDisabled, { path: '/' });
          Loading.show();
          Window.reload();
        }
      });
    },

    buttons: [
      {
        text: "Close",
        className: "btn-primary",
        close: true
      }
    ]
  });
});
